import {
  Box,
  Button,
  Link,
  SnackbarCloseReason,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Fade from '@mui/material/Fade';
import React, { FC, useEffect, useState } from 'react';
import { APP_CONFIG } from '../../const/APP_CONFIG';
import { Colors, SECTION_PADDING } from '../../styles/theme';

const DownloadSection: FC = () => {
  const [value, setValue] = useState('');

  const [open, setOpen] = React.useState(false);
  const [showError, setShowError] = useState(false);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleClose();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  return (
    <Box
      id={'download'}
      sx={{
        width: '100%',
        pt: SECTION_PADDING.py,
        borderTopLeftRadius: '40px',
        borderTopRightRadius: '40px',
        background: `
          url('/images/title_burn.png'),
          conic-gradient(from 66.72deg at 61.28% 50.03%, #7DC9FF -149.29deg, #0095FF 28.51deg, #7DC9FF 210.71deg, #0095FF 388.51deg)
        `,
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
      }}
    >
      <Box
        sx={{
          maxWidth: '1440px',
          mx: 'auto',
          overflow: 'hidden',
          position: 'relative',
          px: SECTION_PADDING.px,
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 700,
            letterSpacing: '-0.6px',
            lineHeight: '130%',
            fontSize: {
              xs: '28px',
              sm: '56px',
              md: '86px',
            },
            color: '#FFFFFF',
            marginBottom: {
              xs: '40px',
              sm: '155px',
              md: '300px',
            },
          }}
        >
          <span
            style={{
              color: '#FFFFFF99',
              fontWeight: 400,
            }}
          >
            {/* Join Waitlist! */}
            Why customers say
          </span>{' '}
          <br />
          {/* Coming soon */}
          'YES' faster.
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            marginBottom: {
              xs: '22px',
              sm: '47px',
              md: '74px',
            },
            fontSize: {
              xs: '16px',
              sm: '24px',
              md: '32px',
            },
            color: '#FFFFFF',
            maxWidth: {
              xs: 'auto',
              sm: '50%',
              md: '40%',
              lg: '30%',
            },
            whiteSpace: 'pre-line',
          }}
        >
          {
            'Send a visual, credible report that builds trust. - no phone calls, no back and forth.\nJust faster approvals.'
          }
          {/* Add your email to the waitlist today for priority access the moment */}
          {/* we launch. */}
        </Typography>
        {/* <Stack
            spacing={'28px'}
            sx={{
              width: { xs: 'auto', sm: '300px', md: '400px' },
              marginBottom: {
                xs: '40px',
                sm: '100px',
                md: '200px',
              },
            }}
            component={'form'}
            onSubmit={(e) => {
              e.preventDefault();
              const email = value.trim();
              if (!/\S+@\S+\.\S+/.test(email)) {
                setShowError(true);
                return;
              }
              setOpen(true);
            }}
          >
            <TextField
              variant="outlined"
              placeholder="name@gmail.com"
              type="email"
              fullWidth
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                setShowError(false);
              }}
              error={showError}
              helperText={showError ? 'Please enter a valid email.' : ''}
              sx={{
                marginBottom: '10px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  padding: {
                    xs: '12px 24px',
                    sm: '14px 24px',
                    md: '14px 24px',
                  },
                  backgroundColor: 'white',
                  '& fieldset': {
                    border: '3px solid #238AFF',
                  },
                  '&:hover fieldset': {
                    border: '3px solid #238AFF',
                  },
                  '&.Mui-focused fieldset': {
                    border: '3px solid #238AFF',
                  },
                },
                '& input': {
                  padding: 0,
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '140%',
                  letterSpacing: '0%',
                  color: '#707070',
                },
                width: '100%',
                height: '40px',
              }}
              InputProps={{
                sx: {
                  padding: 0,
                },
              }}
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: Colors.blue,
                color: 'white',
                padding: '16px 32px',
                fontWeight: 700,
                fontSize: 16,
                borderRadius: '8px',
                textTransform: 'none',
                width: '100%',
                height: '50px',
              }}
              type="submit"
            >
              Join the waitlist
            </Button>
            <Fade in={open}>
              <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                sx={{
                  width: '100%',
                  marginTop: '16px',
                  backgroundColor: Colors.blue,
                  fontSize: '16px',
                }}
              >
                You’re on the waitlist! We’ll notify you as soon.
              </Alert>
            </Fade>
          </Stack> */}
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: '#000000',
            fontSize: {
              xs: '16px',
              sm: '24px',
              md: '32px',
            },
            marginBottom: '16px',
          }}
        >
          Tap to Start!
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: {
              xs: '10px',
              sm: '18px',
            },
            marginBottom: {
              xs: '40px',
              sm: '100px',
            },
            flexDirection: { xs: 'row', sm: 'column', md: 'row' },
          }}
        >
          <Link href={APP_CONFIG.download.ios} target="_blank" rel="noopener">
            <Box
              component="img"
              src="/images/badge_ios.png"
              alt="Download on the App Store"
              sx={{
                height: { xs: '40px', sm: '60px' },
                cursor: 'pointer',
                display: 'block',
              }}
            />
          </Link>
          <Link
            href={APP_CONFIG.download.android}
            target="_blank"
            rel="noopener"
          >
            <Box
              component="img"
              src="/images/badge_aos.png"
              alt="Get it on Google Play"
              sx={{
                height: { xs: '40px', sm: '60px' },
                cursor: 'pointer',
                display: 'block',
              }}
            />
          </Link>
        </Box>
        <Box
          sx={{
            position: {
              xs: 'static',
              sm: 'absolute',
            },
            top: {
              sm: '324px',
              md: '300px',
            },
            right: {
              sm: '40px',
            },
            width: {
              xs: '100%',
              sm: '40%',
              md: '45%',
            },
            height: {
              xs: '300px',
              sm: '400px',
              md: 'auto',
            },
            mx: {
              xs: 'auto',
              sm: 0,
            },

            pointerEvents: 'none',
            userSelect: 'none',
            display: 'block',
            marginTop: {
              xs: '16px',
              sm: 0,
            },
            marginBottom: {
              xs: 0,
              sm: 0,
            },
            overflow: 'hidden', // 이미지가 컨테이너를 넘지 않도록
          }}
        >
          <Box
            component="img"
            src="/images/haist/download-bg.png"
            alt="Smartphone with AI interface"
            sx={{
              width: '100%',
              height: {
                xs: '100%',
                md: 'auto',
              },
              display: 'block',
              maxWidth: '100%',
              objectFit: 'cover',
              objectPosition: 'top',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadSection;
